var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.579 494.166C244.451 501.945 255.549 501.945 259.421 494.166L316.994 378.504C330.259 351.855 351.855 330.259 378.504 316.994L494.166 259.421C501.945 255.549 501.945 244.451 494.166 240.579L378.504 183.006C351.855 169.741 330.259 148.145 316.994 121.496L259.421 5.83416C255.549 -1.94474 244.451 -1.94474 240.579 5.83416L183.006 121.496C169.741 148.145 148.145 169.741 121.496 183.006L5.83418 240.579C-1.94472 244.451 -1.94473 255.549 5.83418 259.421L121.496 316.994C148.145 330.259 169.741 351.855 183.006 378.504L240.579 494.166Z",
    fill: "#BDE6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b4822e792fa91c64811c4df2c7590856.svg";
export { ForwardRef as ReactComponent };